<template>
  <shared-step-editor-modal
    :open="open"
    :title="title"
    closeText="Close"
    confirmText="Confirm"
    @confirm="handleConfirm"
    @close="handleClose"
  >
    <shared-modal-smart-input-group v-for="item of smartItems" :key="item.name" v-model="item.content" :name="item.header" @update="(value) => item.content = value" />
    <shared-modal-input-group v-for="item of items" :key="item.name" v-model="item.content" :name="item.header" />
  </shared-step-editor-modal>
</template>

<script>
import SharedStepEditorModal from '../../shared/SharedStepEditorModal';
import SharedModalInputGroup from '../../shared/modal/SharedModalInputGroup';
import SharedModalSmartInputGroup from "./SharedModalSmartInputGroup.vue";
export default {
  components: {SharedModalSmartInputGroup, SharedStepEditorModal, SharedModalInputGroup},
  props: {
    pieces: Array,
    smartPieces: Array,
    heading: String,
    open: Boolean,
    title: String,
  },
  data: () => ({
    items: [],
    smartItems: [],
  }),
  methods: {
    handleConfirm() {
      const newPieces = {};
      this.items.forEach(item => {
        newPieces[item.name] = item.content;
      });
      this.smartItems.forEach(item => {
        newPieces[item.name] = item.content;
      });

      this.$emit('update', newPieces);
    },
    handleClose() {
      this.$emit('close');
    },
    loadData() {
      this.items = this.pieces ? JSON.parse(JSON.stringify(this.pieces)) : [];
      this.smartItems = this.smartPieces ? JSON.parse(JSON.stringify(this.smartPieces)) : [];
    }
  },
  mounted() {
    this.loadData()
  },
  watch: {
    pieces() {
      this.loadData()
    },
    smartPieces() {
      this.loadData()
    }
  }
};
</script>

<style scoped lang="scss"></style>
